<template>
  <pu-search-link
    v-if="useLink"
    :search-filters="getModifiedSearchFilters({ bounds: undefined })"
    category="search"
  >
    <translate>Custom map area</translate>
    <img
      src="@/assets/images/close-x.svg"
      class="icon"
      width="18"
      height="18"
      alt=""
    />
  </pu-search-link>
  <span v-else class="search-summary-detail-bounds">
    <translate>Custom map area</translate>
    <img
      src="@/assets/images/close-x.svg"
      class="icon"
      width="18"
      height="18"
      alt=""
      @click="$emit('remove', getModifiedSearchFilters({ bounds: undefined }))"
    />
  </span>
</template>

<script lang="ts">
import type { SearchFilters } from '~/apps/search/schemas'
import { isLocalStorageAvailable } from '~/utility/isLocalStorageAvailable'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

interface PreviousSearch {
  previousPath?: string
  previousPoint?: {
    area?: SearchFilters['area']
    placename?: SearchFilters['placename']
  }
}

@Component
class SearchSummaryBarDetailsBounds extends Vue {
  @Prop()
  searchFilters: SearchFilters

  @Prop({ default: true })
  useLink: boolean

  isMounted = false

  mounted() {
    this.isMounted = true
  }

  getModifiedSearchFilters(filters: Partial<SearchFilters>) {
    const filtersToUpdate = { ...filters }
    if (this.previousNonBoundsSearch?.previousPath) {
      filtersToUpdate.hierarchyPath = this.previousNonBoundsSearch.previousPath
    }
    if (this.previousNonBoundsSearch?.previousPoint) {
      const { area, placename } = this.previousNonBoundsSearch.previousPoint
      filtersToUpdate.area = area
      filtersToUpdate.placename = placename
    }
    return { ...this.searchFilters, ...filtersToUpdate }
  }

  get previousNonBoundsSearch() {
    if (isLocalStorageAvailable() && this.isMounted) {
      const storedPreviousSearch = localStorage.getItem('maps-previous-search')
      return storedPreviousSearch ? JSON.parse(storedPreviousSearch) : undefined
    } else {
      return undefined
    }
  }
}

export default toNative(SearchSummaryBarDetailsBounds)
</script>
